import type { AutocompleteIndices } from '../types'

export const getAutocompleteIndices = (): AutocompleteIndices => ({
	main: process.env.NEXT_PUBLIC_ALGOLIA_INDEX ?? '',
	suggestions: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_QUERY_SUGGESTIONS ?? '',
	playlists: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_PLAYLISTS ?? '',
	collections: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_COLLECTIONS ?? '',
})
